import React, { useContext } from 'react';
import PropTypes from '@squiz/xaccel-prop-types';
import { generateClasses } from '@squiz/xaccel-utility-functions';
import AssistedInputContext from './AssistedInputContext';
import styles from '../css/global.module.scss';

/**
 * AssistedInputLabel.
 *
 * @param {bool} showLoader Flag to determine whether to show the loader.
 * @param {classNameOverride} className The class names to put in class attribute of label.
 * @param {node} children The node to placed inside label element.
 *
 * @return {JSX.Element}
 * @constructor
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AssistedInputLabel(_ref) {
  let {
    showLoader,
    className,
    children
  } = _ref;
  const {
    id,
    isFetching
  } = useContext(AssistedInputContext);
  return /*#__PURE__*/_jsxs("label", {
    "aria-live": "polite",
    id: `assisted-input-label-${id}`,
    htmlFor: `assisted-input-${id}`,
    className: generateClasses({
      block: 'assisted-input-label',
      modifiers: {
        fetching: isFetching
      },
      override: className
    }, styles),
    children: [children, showLoader && isFetching && /*#__PURE__*/_jsx("div", {
      id: `assisted-input-loader-${id}`,
      className: generateClasses({
        block: 'assisted-input-label',
        element: 'loader',
        override: className
      }, styles),
      "aria-hidden": "true"
    })]
  });
}
AssistedInputLabel.propTypes = {
  showLoader: PropTypes.bool,
  className: PropTypes.classNameOverride,
  children: PropTypes.node
};
AssistedInputLabel.defaultProps = {
  showLoader: true,
  className: undefined,
  children: undefined
};
export default AssistedInputLabel;